import React, { useEffect, useState } from "react";
import { Table, Button, Container, Form, Modal } from "react-bootstrap";
import { PencilSquare, Trash, Check, X } from "react-bootstrap-icons";


// ------------ Page Imports ---------------

import "../../../App.css";
import SideMenu from "../../../Components/SideDrawer";
import PageHeader from "../../../Components/Header";
import { teamDelete, teamEdit, teamPost, teamGet, companyGet } from "../../../Api/Admin/AdminApi";
import { extractErrorMessage } from "../../../Utils/ErrorUtlis";


const Team = () => {
  const [apiData, setApiData] = useState([]);
  const [company, setCompany] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingCompany, setLoadingComapany] = useState(false)
  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    team_name: "",
    description: "",
    company_id: null
  });
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleitingId, setDeletingId] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editFormData, setEditFormData] = useState({
    team_name: "",
    description: "",
    company_id: null
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await teamGet();
        if (data) {
          const team = data.results.map(i => ({
            id: i.team_id,
            team_name: i.team_name,
            description: i.description,
            companyId: i.company_id,
          }));
          setApiData(team);
          setIsLoading(false);
          console.log(apiData)
        }
      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }

    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setCompany(companies);
          setLoadingComapany(true)
          console.log(`API Data ${JSON.stringify(company)}`);  // Under Production         
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchData();
    fetchCompany();
  }, [])

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowAddModal(false)
    try {
      const response = await teamPost(formData);
      if (response) {
        <div className="alert" role="alert">
          New Team Created..
        </div>
        window.location.reload();
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }


  const handleEditClick = (teamData) => {
    setShowEditModal(true);
    setEditFormData({
    team_name: teamData.team_name,
    description: teamData.description,
    company_id: teamData.companyId
    });
  };
  const handleCancelClick = () => {
    setEditingId(null);
  }


  const handleEditFormChange = (event) => {
    const { name, value } = event.target;
    setEditFormData({
      ...editFormData,
      [name]: value
    });
  };

  const handleEditSubmit = async () => {
    setShowEditModal(false);
    try {
      const response = await teamEdit(editFormData, editingId);
      if (response) {
        // setEditingId(null)
        window.location.reload();
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Updating Data in Teams: ', errorMessage || err);
      alert(errorMessage)
    }
    setEditFormData({
      team_name: "",
    description: "",
    company_id: null
    })
  }

  const handleDelete = async (id) => {
    console.log('Type of Delete ID: ', typeof id, id);
    
    try {
      const response = await teamDelete(id);
      if (response) {
        setDeletingId(null);
        window.location.reload();
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Deleting Team Data: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader
          title="Teams"
          showButtons={true}
        />
        <h4 className="mb-4 d-flex justify-content-between align-items-center">
          Team Details
          <div className="d-flex flex-column align-items-end">
            <Button variant="primary" className="d-flex align-items-center mb-2" onClick={() => setShowAddModal(true)}>
              Create+
            </Button>
          </div>
        </h4>
        {isLoading ? <div class="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div> :
          <div style={{ overflow: 'auto' }}>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th className="fs-12">Team Name</th>
                  <th className="fs-12">Description</th>
                  <th className="fs-12">Organization Name</th>
                  <th className="fs-12">Action</th>
                </tr>
              </thead>
              <tbody>
                {apiData.map((teamData, i) => (
                  <tr key={teamData.id}>
                    <td className="fs-12">{teamData.team_name}</td>
                    <td className="fs-12">{teamData.description}</td>
                    <td className="fs-12">
                      {company.find(org => org.id === teamData.companyId)?.name || 'N/A'}
                    </td>
                    <td className="fs-12">
                      <Button variant="outline-primary" size="sm" onClick={() => {
                        setEditingId(teamData.id)
                        handleEditClick(teamData)
                      }} >
                        <PencilSquare />
                      </Button >
                      <Button variant="outline-primary" size="sm" onClick={() => {
                          setDeletingId(teamData.id)
                          setShowDeleteModal(true)
                        }} >
                        <Trash />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        }
        <Modal show={showAddModal} onHide={() => setShowAddModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Create New Team</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3" controlId="team_name">
                <Form.Label>Team Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="team_name"
                  value={formData.team_name}
                  onChange={handleFormChange}
                  required
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-3" controlId="description">
                <Form.Label>Description *</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={formData.description}
                  onChange={handleFormChange}
                  required
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-3" controlId="company_id">
                <Form.Label>Organization Name</Form.Label>
                <Form.Select
                  name="company_id"
                  value={formData.company_id}
                  onChange={handleFormChange}
                  style={{ height: '38px' }}
                >
                  <option value=''>Select Organization</option>
                  {company.map(i => (
                    <option key={i.id} value={i.id}>{i.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body> 
          <Modal.Footer>
            <Button variant="warning" onClick={() => setShowAddModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Edit Modal for Teams */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Update Team</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3" controlId="team_name">
                <Form.Label>Team Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="team_name"
                  value={editFormData.team_name}
                  onChange={handleEditFormChange}
                  required
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-3" controlId="description">
                <Form.Label>Description *</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={editFormData.description}
                  onChange={handleEditFormChange}
                  required
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-3" controlId="company_id">
                <Form.Label>Organization Name</Form.Label>
                <Form.Select
                  name="company_id"
                  value={editFormData.company_id}
                  onChange={handleEditFormChange}
                  style={{ height: '38px' }}
                >
                  <option value=''>Select Organization</option>
                  {company.map(i => (
                    <option key={i.id} value={i.id}>{i.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body> 
          <Modal.Footer>
            <Button variant="warning" onClick={() => setShowAddModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handleEditSubmit}>
              Update
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Delete Modal */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Congirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are You Want to delete This Organization?..</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>NO</Button>
            <Button variant="warning" onClick={() => {
              handleDelete(deleitingId);
              setShowDeleteModal(false);
            }}>YES</Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  )
};

export default Team;